import { render, staticRenderFns } from "./bv-picker-windows.vue?vue&type=template&id=76ff1a48&scoped=true"
import script from "./bv-picker-windows.vue?vue&type=script&lang=js"
export * from "./bv-picker-windows.vue?vue&type=script&lang=js"
import style0 from "./bv-picker-windows.vue?vue&type=style&index=0&id=76ff1a48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../apps/gouwubao/node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ff1a48",
  null
  
)

export default component.exports